import React, { useState } from 'react';

const TUTORIAL_STEPS = [
  {
    icon: '\uD83D\uDE80',
    title: 'Welcome to __BRAND_NAME__',
    description: 'Your all-in-one platform for managing operations, customers, invoicing, and compliance. Built by Miskulin Technologies to streamline your workflow and boost productivity.'
  },
  {
    icon: '\uD83D\uDDFA\uFE0F',
    title: 'Navigation Overview',
    description: 'Use the sidebar to navigate between sections. Owners and admins get access to Overwatch for a high-level view. Your role determines which sections are visible.'
  },
  {
    icon: '\u2B50',
    title: 'Key Features',
    description: 'Manage customers and contacts, create and track invoices, generate compliance reports, and monitor real-time analytics. Everything you need in one place.'
  },
  {
    icon: '\u2705',
    title: 'Getting Started',
    description: 'Start by exploring the Dashboard for a quick overview. Add your first customer, create an invoice, or check compliance status. Need help? Visit your Profile for support options.'
  }
];

export default function AppTutorialPage({ onComplete }) {
  const [step, setStep] = useState(0);
  const current = TUTORIAL_STEPS[step];
  const isLast = step === TUTORIAL_STEPS.length - 1;

  const handleNext = () => {
    if (isLast) {
      onComplete();
    } else {
      setStep(step + 1);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{
        width: '100%', maxWidth: 520, padding: 40, background: 'var(--card)',
        borderRadius: 16, border: '1px solid var(--border)', boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
      }}>
        {/* Progress indicators */}
        <div style={{ display: 'flex', gap: 6, justifyContent: 'center', marginBottom: 32 }}>
          {TUTORIAL_STEPS.map((_, i) => (
            <div key={i} style={{
              width: i === step ? 32 : 8, height: 8, borderRadius: 4,
              background: i === step ? 'var(--primary)' : i < step ? 'var(--accent)' : 'var(--border)',
              transition: 'all 0.3s ease'
            }} />
          ))}
        </div>

        {/* Step content card */}
        <div className="card" style={{
          textAlign: 'center', padding: 32, background: 'var(--bg)',
          borderRadius: 12, border: '1px solid var(--border)', marginBottom: 28
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>{current.icon}</div>
          <h2 className="card-title" style={{
            color: 'var(--text)', fontSize: 22, fontWeight: 700, margin: '0 0 12px'
          }}>
            {current.title}
          </h2>
          <p style={{
            color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.7, margin: 0
          }}>
            {current.description}
          </p>
        </div>

        {/* Step counter */}
        <p style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: 12, marginBottom: 16 }}>
          Step {step + 1} of {TUTORIAL_STEPS.length}
        </p>

        {/* Navigation buttons */}
        <div style={{ display: 'flex', gap: 12 }}>
          {step > 0 && (
            <button
              onClick={() => setStep(step - 1)}
              style={{
                flex: 1, padding: '12px 0', background: 'transparent',
                border: '1px solid var(--border)', borderRadius: 8,
                color: 'var(--text-secondary)', fontSize: 14, fontWeight: 600, cursor: 'pointer'
              }}
            >
              Back
            </button>
          )}
          <button
            className="btn btn-primary"
            onClick={handleNext}
            style={{
              flex: 1, padding: '12px 0', background: 'var(--primary)', color: '#fff',
              border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer'
            }}
          >
            {isLast ? 'Get Started' : 'Next'}
          </button>
        </div>

        {/* Skip option */}
        {!isLast && (
          <button
            onClick={onComplete}
            style={{
              display: 'block', width: '100%', marginTop: 12, padding: 8,
              background: 'transparent', border: 'none', color: 'var(--text-muted)',
              fontSize: 12, cursor: 'pointer'
            }}
          >
            Skip Tutorial
          </button>
        )}
      </div>
    </div>
  );
}
